import request from '../utils/request';

/**
 * 获取用户设备分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export const getUserDeviceList = (params) => {
  console.log("params",params);
  return request({
    url: '/user-device/list',
    method: 'get',
    params
  });
}; 